import { round } from 'lodash';

const formatPercentage = percentage =>
  percentage === -1 ? 'unknown' : `${round(percentage, 2)}%`;

export default formatPercentage;
